import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { addEvent, updateEvent } from "../../db";

const EventForm = ({ event = null }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    // ✅ Initialize eventData with defaults
    const [eventData, setEventData] = useState({
        id: event?.id || null,
        title: event?.title || "",
        type: event?.type || "",
        date: event?.date || Math.floor(Date.now() / 1000), // Fallback to now
    });

    // ✅ Update state if editing an existing event
    useEffect(() => {
        if (event) {
            setEventData({
                id: event.id,
                title: event.title || "",
                type: event.type || "",
                date: event.date || Math.floor(Date.now() / 1000),
            });
        }
    }, [event]);

    const handleSave = async () => {
        if (!isValid()) return;

        try {
            if (eventData.id) {
                await updateEvent(eventData.id, eventData);
                navigate(`/events/${eventData.id}`);
            } else {
                const newEventId = await addEvent(eventData);
                if (newEventId) {
                    navigate(`/events/${newEventId}`);
                } else {
                    console.error("Failed to add event, ID is null.");
                }
            }
        } catch (error) {
            console.error("Error saving event:", error);
        }
    };

    const isValid = () => {
        return eventData.title.trim() !== "";
    };

    return (
        <div className="flex flex-col gap-6 px-2">
            <div className="pt-4 gap-4 grid sm:grid-cols-2 md:grid-cols-4">
                <div className="flex flex-col gap-2 sm:col-span-2">
                    <label htmlFor="eventTitle" className="font-bold">
                        {t("event.title")}
                    </label>
                    <div className="form-input-wrap">
                        <input
                            id="eventTitle"
                            value={eventData.title}
                            onChange={(e) => setEventData({ ...eventData, title: e.target.value })}
                        />
                    </div>
                </div>

                <div className="flex flex-col gap-2 sm:col-span-2">
                    <label htmlFor="eventDate" className="font-bold">
                        {t("event.date")}
                    </label>
                    <div className="form-input-wrap form-input-wrap-date">
                        <DatePicker
                            id="eventDate"
                            selected={new Date(eventData.date * 1000)}
                            onChange={(date) =>
                                setEventData({ ...eventData, date: Math.floor(date.getTime() / 1000) })
                            }
                            dateFormat="dd.MM.yyyy"
                            className="w-full"
                        />
                    </div>
                </div>

                <div className="flex flex-col gap-2 sm:col-span-2">
                    <label htmlFor="eventType" className="font-bold">
                        {t("event.type")}
                    </label>
                    <div className="form-input-wrap">
                        <select
                            id="eventType"
                            value={eventData.type}
                            onChange={(e) => setEventData({ ...eventData, type: e.target.value })}
                        >
                            <option value="">{t("event.type.none") || "-"}</option>
                            <option value="training">{t("event.type.training")}</option>
                            <option value="race">{t("event.type.race")}</option>
                        </select>
                    </div>
                </div>
            </div>

            <div>
                <button onClick={handleSave} className="button-primary">{t("event.save")}</button>
            </div>
        </div>
    );
};

export default EventForm;
